/* eslint-disable multiline-comment-style */

/*
 *  EventFilter mixin provides the data structure and computed properties and methods
 *  to handle the client-side filtering of event data.
 *
 *  - Event Type
 *  - Text (general text filter)
 *
 */

export const EventFilter = {
    data() {
        return {
            filter: {
                eventtype: {meeting: true, course: true, sectypecode: ''},
                text: ''
            }
        };
    },
    computed: {

        /**
         * Returns true if there are data filtering exclusions. Does not include date/location, since those cause a data refresh with AJAX.
         * @returns {boolean} Whether there are data filtering exclusions.
         */
        filterHasExclusions() {
            // This only returns true if there are data filtering exclusions.
            // So this does not include date/location, since those cause data refresh with AJAX.
            let answer = false;
            if (this.filter.eventtype.course === false || this.filter.eventtype.meeting === false) answer = true;
            if (this.filter.eventtype.sectypecode.length) answer = true;
            if (this.filter.text.length) answer = true;
            return answer;
        },

        /**
         * Returns the events array with the filters applied.
         * @returns {Array} Filtered array of events.
         */
        eventsFiltered() {
            return this.events.filter(this.eventFilter);
        }
    },
    methods: {

        /**
         * The event filter, using event type and text.
         * @param {Array} event The event to evaluate for filtering.
         * @returns {Boolean} Whether the event matches the filter criteria.
         */
        eventFilter(event) {
            let criMatch = false;
            // Event type checks
            if (this.filter.eventtype.meeting && event.isMeeting) criMatch = true;
            if (
                this.filter.eventtype.course &&
                event.isAcademic &&
                (this.filter.eventtype.sectypecode.length == 0 ||
                    this.filter.eventtype.sectypecode == event.sectypecode)
            ) {
                criMatch = true;
            }
            // Text match. Loop thru each word, search for any match in given fields (if no filter, consider it a match)
            let textMatch = this.filter.text.length == 0 && criMatch;
            if (criMatch) {
                this.filter.text.split(' ').forEach(txt=>{
                    if (!textMatch) {
                        if (this.stringContains(event.title, txt)) textMatch = true;
                        if (this.stringContains(event.location, txt)) textMatch = true;
                        if (this.stringContains(event.facname, txt)) textMatch = true;
                    }
                });
            }
            return criMatch && textMatch;
        },

        /**
         * Returns whether some text matches a string.
         * @param {String} str The string to search in.
         * @param {String} txt The text to match in the string.
         * @returns {Boolean} Whether the string matches.
         */
        stringContains(str, txt) {
            const stringToSearch = str || '';
            return (
                stringToSearch
                    .toString()
                    .toLowerCase()
                    .indexOf(txt.toLowerCase()) >= 0
            );
        }
    }
};